import User from '@unified/js-common/lib/user/User'
import StorageProxy from '@unified/js-common/lib/lib/StorageProxy'

const storage = new StorageProxy()

export const getStorage = (key: string) => {
  return storage.getJsonItem(key, User.identityId())
}

export const setStorage = (key: string, value: any) => {
  storage.setItem(key, value, User.identityId())
}

export const removeStorage = (key: string) => {
  return storage.removeItem(key, User.identityId())
}

export const clearStorage = () => {
  storage.clear()
}
